var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoss"},_vm._l((_vm.videos),function(item,index){return _c('small-videos-list-item',{key:item.title,staticClass:"now",attrs:{"videos-item":item,"videos-index":index,"type":_vm.type,"stype":_vm.stype}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }